module.exports = __webpack_public_path__ + "img/库位校验.9c72535f.svg";